import * as React from "react";
import { useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ListItemIcon from "@mui/material/ListItemIcon";
import Avatar from "@mui/material/Avatar";
import PersonIcon from "@mui/icons-material/Person";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LogoutIcon from '@mui/icons-material/Logout';
import { colors } from "../../../constants/colors";
import { Menu, MenuItem } from "@mui/material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { iconsHeader } from "../../../assets/icons/icons";
import { setShowNavbar, unsetShowNavbar } from "../../../store/navbar/navbar.slice";
import FilterSelect from "../../select/filterSelect";
import { useTranslation } from "react-i18next";
import { logout } from "../../../utils/app.utils";
import { routeName } from "../../../routes/routeName";
import { RootState } from "../../../store/store";
import { languageEnum } from "../../../constants/enum";
import { USER_TYPE } from "../../../api/front-api/front.api";
import Hashids from "hashids";
import { NotiApi } from "../../../api/noti/noti.api";
import { ReactComponent as NotificationAlarm } from '../../../assets/icons/notification.svg';
import { ReactComponent as Notification } from '../../../assets/icons/ci_bell-notification.svg';
import { ReactComponent as Tick } from '../../../assets/icons/tick-square.svg';
import { ButtonContained, ButtonOutlined } from "../../button/ButtonCustoms";
import { alertSuccess } from "../../alert/swal";


const AvatarBox = styled(Box)(({ theme }) => ({
    display: 'flex', flexDirection: 'column', mx: 1, [theme.breakpoints.down('md')]: {
        display: "none"
    }
}))

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer - 150,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

function EditMenu() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const navigate: NavigateFunction = useNavigate();

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const options = [
        { label: 'บัญชีผู้ใช้', icon: <ManageAccountsIcon />, action: () => navigate("/awdwa") },
        { label: 'ออกจากระบบ', icon: <LogoutIcon />, action: () => logout() },
    ];



    return (
        <div>
            <IconButton
                aria-label="more"
                id="edit-button"
                aria-controls={open ? 'edit-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <ExpandMoreIcon sx={{ color: colors.themeMainColor }} />
            </IconButton>
            <Menu
                id="edit-menu"
                MenuListProps={{
                    'aria-labelledby': 'edit-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        width: '20ch',
                    },
                }}
            >
                {options.map((option) => (
                    <MenuItem key={option.label} onClick={() => {
                        option.action && option.action();
                        // handleClose();
                    }}>
                        <ListItemIcon>{option.icon}</ListItemIcon>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}

export default function Header() {
    const { i18n } = useTranslation();
    const language = localStorage.getItem("lng") || 'th';
    const current_lng = i18n.language;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const profile = useSelector((state: RootState) => state.profile.profile) as any;
    const open = useSelector((state: any) => state?.navbar?.open);
    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);
    const is_employee: boolean = (USER_TYPE.EMPLOYEE === profile?.user_type);
    const [data, setData] = React.useState<any[]>([])


    const handleDrawerOpenButton = () => {
        dispatch(unsetShowNavbar())
        if (!open) {
            dispatch(setShowNavbar())
        }
    }

    const profile_state: { full_name: string, position_name: string } = React.useMemo(() => {
        return {
            full_name: current_lng === languageEnum.TH ?
                `${profile?.first_name || profile?.student_frist_name || ""} ${profile?.last_name || profile?.student_last_name || ""}` :
                `${profile?.first_name_eng || ""} ${profile?.last_name_eng || ""}`,
            position_name: ""
        }
    }, [current_lng, profile])

    

    const getCountNoti = async () => {
        // const res = await NotiAPI.count()
        // const data = res.data
        // if (data.status < 300) {
        //     setCountNoti(data.data)
        // }
    }
    const getList = async () => {
        let params = {
            page: 1,
            limit: 100,
            status_notification: 'UNREAD'
        }
        await NotiApi.list(params).then((res) => {
            const data = res.data
            if (data?.status < 300) {
                setData(data.data?.items);

            }

        }).catch((error) => {
            console.log(error)
            // setOpenError(true)
            // setCode(error?.response?.status)
        })
    }
    useEffect(() => {
        getCountNoti()
        getList()
    }, [])

    const [anchorElNoti, setAnchorElNoti] = React.useState<null | HTMLElement>(null)
    const openNoti = Boolean(anchorElNoti)
    // const handleToggleNoti = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     setAnchorElNoti(event.currentTarget)
    // }
    const handleCloseNoti = () => {
        setAnchorElNoti(null)
    }


    const handleClickNoti = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNoti(event.currentTarget);
    };

    const translationData = [
        {
            key: "THAI",
            data: 'th',
            imgUrl: iconsHeader?.thai
        },
        {
            key: "ENGLISH",
            data: 'en',
            imgUrl: iconsHeader?.english
        },
    ]

    const handleChangeLanguage = (lang: string) => {
        const langMiss: string[] = ['en', 'th'];
        if (langMiss.includes(lang)) {
            i18n.changeLanguage(lang);
            localStorage.setItem('lng', lang);
        }
        return false
    }
    useEffect(() => {
        if (!language) {
            localStorage.setItem('lng', 'th');
        } else {
            i18n.changeLanguage(language);
        }
    }, [language])
    const handleSubmit = async (id: any) => {

        await NotiApi.patch(id).then((res: any) => {
            const data = res?.data
            if (data.status < 300) {
                alertSuccess('รับทราบแล้ว')
                getList()
            }
        }).catch((error: any) => console.log(error?.response))
    }
    return (
        <Box sx={{
            // border: "2px solid #000"
            position: 'fixed',
            top: '0px',
            width: '100%',
            zIndex: '2'
        }}>
            <CssBaseline />
            {open && (
                <Box
                    onClick={() => navigate(routeName.main.home)}
                    sx={{ position: "absolute", left: 0, top: 0, maxWidth: 320, height: 67, borderBottom: "1px solid #000", backgroundColor: "#fff" }}
                    className="w-full flex justify-center cursor-pointer items-center">
                    <img
                        src={iconsHeader.logo}
                        alt="logo"
                        style={{ width: "56px", height: "56px", objectFit: "contain" }}
                    />
                </Box>
            )}

            <AppBar
                position="static"
                open={open}
                sx={{
                    backgroundColor: "white",
                    boxShadow: "none",
                    borderBottom: "1px solid",
                    borderColor: colors.bgMainColor,
                    minHeight: "67px",
                }}
                color="inherit"
            >
                <Toolbar>
                    <Box sx={{
                        m: 0, p: 0,
                        ...(open && { display: "none" })
                    }}>
                    </Box>
                    {open ? <></> :
                        <div className="ml-3">
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={() => {
                                    handleDrawerOpenButton();

                                }}
                                edge="start"
                                sx={{
                                    marginRight: 5,
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                        </div>
                    }
                    <div style={{ flexGrow: 1 }}></div>
                    <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ m: 1.5, color: colors.textLightGray }}
                    />

                    <Box onClick={() => {
                        if (is_employee) {
                            const id_hash_ids = hash_ids.encode(profile?.id_employee);
                            return navigate(routeName.cms_website.profile_employee.replace(":id", id_hash_ids));
                        } else {
                            // อื่นๆที่ไม่ใช้บุคลากร
                        }
                    }} className="flex cursor-pointer justify-start items-center gap-2">
                        <Avatar className="me-2">
                            <PersonIcon />
                        </Avatar>
                        <Typography>
                            {profile_state.full_name}
                        </Typography>
                    </Box>


                    <AvatarBox >
                    </AvatarBox>
                    <EditMenu />
                    <div className='flex justify-center items-center mx-[10px]'>
                        <IconButton sx={{ borderRadius: "8px !important", border: "1px solid rgba(0,0,0,0.12)" }} aria-controls={openNoti ? 'demo-positioned-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={openNoti ? 'true' : undefined}
                            onClick={handleClickNoti}>
                            {data?.length > 0 ?
                                <Notification /> :
                                <NotificationAlarm />}
                        </IconButton>

                    </div>
                    <div className="w-full max-w-[80px]">
                        <FilterSelect
                            style={{ padding: 0 }}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeLanguage(e.target.value)}
                            value={language}
                            labelId={"1"}
                            selectId={"1"}
                            options={translationData.map((x) => {
                                return (
                                    <MenuItem value={x.data} key={x.key}>
                                        <img src={x.imgUrl} alt={`lang-${x?.key}`} />
                                    </MenuItem>
                                )
                            })}
                        />
                    </div>
                </Toolbar>
            </AppBar>
            <Menu
                id="basic-menu"
                anchorEl={anchorElNoti}
                open={openNoti}
                onClose={handleCloseNoti}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box sx={{ padding: '10px 30px' }}>
                    <Box sx={{ display: "flex", gap: '10px', alignItems: "center" }}><NotificationAlarm /><Typography>แจ้งเตือน</Typography></Box>
                    <Divider sx={{ margin: '10px 0px' }} />
                    <Typography>ยังไม่ได้อ่าน</Typography>
                    <Box sx={{ display: "flex", flexDirection: 'column', gap: '10px', overflowY: 'auto', maxHeight: '500px' }}>
                        {data?.length > 0 ? data?.map((item: any, index: number) => {
                            const id_agreements: string = item?.id_ref_2 || "";
                            return (
                                <Box key={index + 1} sx={{ width: '500px', padding: '10px 0px' }}>
                                    <Typography className='line-clamp-5' sx={{
                                        fontSize: '18px', whiteSpace: 'pre-line'
                                    }}>
                                        {item?.notification_log}
                                    </Typography>
                                    < Box sx={{ display: "flex", gap: '10px', justifyContent: "flex-end", marginTop: '10px' }}>
                                        <ButtonOutlined buttonName='ดูข้อมูล' disabled={item?.notification_log_type === 'SERVICE_TICKET_JOB_ASSIGN' || item?.notification_log_type === 'SERVICE_TICKET_JOB_DETAIL_CLOSE_REJECT'} onClick={() => {
                                            handleCloseNoti()
                                            switch (item?.notification_log_type) {
                                                case 'VISA_REQUEST':
                                                    return item?.link ? window.location.href = item?.link : navigate(profile.user_type === 'employee' ? `/manage-request/${item?.id_ref}/view` : `/visa-request-detail/${item?.id_ref}/view`)
                                                case 'REQUEST_APPROVE_ITEM':
                                                    return item?.link ? window.location.href = item?.link : navigate('/approve-item');
                                                case 'APPROVE_AGREEMENT_WORK_PROCESS':
                                                    return item?.link
                                                        ? window.location.href = item.link
                                                        : navigate("/contract", {
                                                            state: {
                                                                id_agreements: id_agreements,
                                                                id_work_process: item?.id_ref
                                                            }
                                                        });
                                                default:
                                                    return item?.link ? window.location.href = item?.link : navigate('/NotiList')
                                            }
                                        }} />
                                        {item?.status_notification === 'UNREAD' && <ButtonContained buttonName='รับทราบ' mode='add' iconComponent={<Tick />} onClick={() => {
                                            handleSubmit(item?.id_notification)
                                        }} />}
                                    </Box>
                                </Box>
                            )
                        }) : <Typography sx={{ margin: '10px 140px' }}>ไม่มีแจ้งเตือนใหม่</Typography>}
                    </Box>
                    {/* <Box sx={{ display: "flex", gap: '10px', justifyContent: "flex-end" }}><Typography sx={{ cursor: 'pointer' }} onClick={() => {
                        navigate('/NotiList')
                        handleCloseNoti()
                    }}>ดูทั้งหมด</Typography></Box> */}
                </Box>

            </Menu>
        </Box >
    );
}
